import createIntlWithLocale from '../../internal/createIntlWithLocale';
import { handleReactIntlError } from '../../internal/errors/handleReactIntlError/handleReactIntlError';
import mergeOptions from '../../internal/mergeOptions';
import fixNegativeZero from '../../internal/number-formatter/fixNegativeZero';
import fixRounding from '../../internal/number-formatter/fixRounding';
/**
 * @see https://sail.stripe.me/apis/intl/useIntl#format-percent
 */ export default function formatPercent(/** The intl config object containing the locale data. When using this API through the `useIntl` hook, this config object is automatically injected. */ config, reports, analytics, /** The number to be formatted, must be a floating-point number between 0 and 1. */ number, /** An object with options to customize the formatting. */ options) {
    const defaults = {
        locale: config.locale,
        maximumFractionDigits: 0,
        signDisplay: 'auto'
    };
    const optionsWithDefaults = mergeOptions(config, defaults, reports, options, {
        style: 'percent'
    });
    let consolidatedNumber = number;
    consolidatedNumber = fixNegativeZero(number);
    consolidatedNumber = fixRounding(consolidatedNumber, 2 + optionsWithDefaults.maximumFractionDigits, optionsWithDefaults.roundingMode);
    const intl = createIntlWithLocale(optionsWithDefaults.locale, config, reports, analytics);
    try {
        return intl.formatNumber(consolidatedNumber, optionsWithDefaults);
    } catch (error) {
        handleReactIntlError(reports, analytics, config.locale, error);
        return '';
    }
}

//# sourceMappingURL=formatPercent.js.map